import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },

  {
    path: '/game',
    name: 'Game',
    component: () => import('../views/Game.vue'),
    meta: { title: '旗下游戏' }
  },

  {
    path: '/display',
    name: 'Display',
    component: () => import('../views/Display.vue'),
    meta: { title: '加入我们' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: { title: '联系我们' }
  },
  {
    path: '/demandInfo',
    name: 'demandInfo',
    component: () => import('../views/DemandInfo.vue'),
    meta: { title: '需求信息' }
  },
  {
    path: '/displayDetail',
    name: 'displayDetail',
    component: () => import('../views/DisplayDetail.vue'),
    meta: { title: '展厅详情' }
  },
  {
    path: '/publish',
    name: 'publish',
    component: () => import('../views/Publish.vue'),
    meta: { title: '发布申请' }
  },
  {
    path: '/ai',
    name: 'Ai',
    component: () => import('../views/Ai/index.vue'),
    meta: { title: 'ai绘画展示' }
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    component: () => import('../views/userCenter.vue'),
    meta: { title: '用户中心' }
  },
  // {
  //   path: '/Product',
  //   name: 'Product',
  //   component: () => import('../views/Product.vue')
  // }
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  // mode: 'history',// 将这里的'mode'属性从'hash'改为'history'
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到页面顶部
    return { x: 0, y: 0 };
  }
})

// router.afterEach((to) => {
//   document.title = `${to.meta.title || ''}-杭州安略科技股份有限公司`
// })
document.title = '安略网络'
// 需要添加内容
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
